/**
 * VueFade
 * Add class when element enters visible area.
 */
import directive from './directive'

const VueFadein = {
  install: function(Vue, options) {

    Vue.directive('inview', directive);
  }
}
export default VueFadein



// WEBPACK FOOTER //
// ./src/plugins/vue-inview/index.js